import styled from "styled-components";

export const TableWrapper = styled.div`
  position: relative;
  padding-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  margin: 0 auto;
`;

export const StyledTable = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;

  th.col-left,
  td.col-left {
    width: 500px;
    background: ${({ leftBg }) => leftBg ||
      "radial-gradient(173.59% 962.83% at -69.18% 47.66%, #800000 0%, #1f1f1f 100%)"};
    color: #ffffff;
  }

  th.col-right,
  td.col-right {
    width: 500px;
    background: ${({ rightBg }) => rightBg ||
      "radial-gradient(170.05% 170.05% at -39.67% 47.66%, #00abba 0%, #003188 100%)"};
    color: #ffffff;
  }

  th.col-left {
    border-radius: 12px 0 0 0;
    position: relative;
    overflow: visible;
  }

  th.col-right {
    border-radius: 0 12px 0 0;
  }

  tbody tr:last-child td.col-left {
    border-radius: 0 0 0 12px;
  }

  tbody tr:last-child td.col-right {
    border-radius: 0 0 12px 0;
  }

  thead tr th {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    padding: 30px 20px 14px 20px;
    height: 100px;
    white-space: wrap;
    border-bottom: 1px solid rgba(255, 255, 255, 0.45);
    @media (max-width: 800px) {
      padding: 10px 10px;
      font-size: 20px;
    }
  }

  thead tr th > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
  }

  tbody tr {
    height: 52px;
  }

  tbody tr td {
    padding: 10px 20px;
    vertical-align: middle;
    font-size: 18px;
    font-weight: 500;
    white-space: wrap;

    @media (max-width: 800px) {
      padding: 10px 10px;
      font-size: 18px;
    }
  }

  tbody tr:last-child td {
    padding-bottom: 50px;
  }
`;

export const CellInner = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const IconImg = styled.img`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  object-fit: contain;
`;

export const RecommendedBadge = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #6fb669;
  border-radius: 8px;
  width: 250px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px !important;
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  padding: 8px 16px;
  white-space: nowrap;
  z-index: 1;

  @media (max-width: 800px) {
    padding: 8px 15px;
    font-size: 16px;
    width: 180px;
  }
`;
